import { Box } from '@mui/material';
import { ReactNode } from 'react';
import NumberInput from '../../../atoms/NumberInput';
import useLocalization from '../../../../hooks/useLocalization';

type Size = 'regular' | 'large';

const styles = {
  container: (width?: number | string) => ({
    width: width ?? '100%',
    display: 'grid',
    gap: 0.375,
    justifyItems: 'stretch',
  }),
  helperMessage: {
    minHeight: 14,
  },
  input: {
    regular: {
      '& .MuiOutlinedInput-root': {
        height: 36,
        borderRadius: 2.5,
        backgroundColor: 'neutral.700',
        color: 'text.primary',
        fontWeight: 700,
        '& fieldset': { borderColor: 'divider' },
      },
      '& .MuiInputBase-input': {
        py: 0.75,
        px: 1,
        fontWeight: 700,
        textAlign: 'right',
        fontSize: 14,
      },
      '& .MuiInputBase-input::placeholder': {
        fontSize: 12,
        color: 'text.disabled',
        opacity: 1,
      },
    },
    large: {
      '& .MuiOutlinedInput-root': {
        height: 44,
        borderRadius: 3,
        backgroundColor: 'neutral.600',
        color: 'text.primary',
        fontWeight: 800,
        '& fieldset': { borderColor: 'divider' },
      },
      '& .MuiInputBase-input': {
        py: 1.125,
        px: 1.5,
        fontWeight: 800,
        textAlign: 'right',
        fontSize: 18,
      },
      '& .MuiInputBase-input::placeholder': {
        fontSize: 18,
        color: 'text.disabled',
        opacity: 1,
      },
    },
  },
} as const;

type NeobetBetslipStakeInputProps = {
  value: string;
  onChange: (value: string) => void;
  width?: number | string;
  testId?: string;
  disabled?: boolean;
  helperMessage?: ReactNode;
  size?: Size;
};

const NeobetBetslipStakeInput = ({
  value,
  onChange,
  width,
  testId,
  disabled,
  helperMessage,
  size = 'regular',
}: NeobetBetslipStakeInputProps) => {
  const { t } = useLocalization();

  return (
    <Box sx={styles.container(width)}>
      {helperMessage ? <Box sx={styles.helperMessage}>{helperMessage}</Box> : null}
      <NumberInput
        size='small'
        variant='outlined'
        placeholder={t('stake', 'Stake')}
        value={value}
        sx={styles.input[size]}
        onChange={onChange}
        disabled={disabled}
        slotProps={{
          htmlInput: {
            inputMode: 'decimal',
            'data-testid': testId,
          },
        }}
      />
    </Box>
  );
};

export default NeobetBetslipStakeInput;
